import { useEffect } from "react";
import * as Sentry from "@sentry/react";
import Cookies from "js-cookie";
import { decodeObject } from "shared/utils/encryption";
const isProduction = process.env.REACT_APP_SENTRY === "true";
const tracesSampleRate = Number(process.env.REACT_APP_SENTRY_TRACES_SAMPLE_RATE ?? 1);
const errorSampleRate = Number(process.env.REACT_APP_SENTRY_ERROR_SAMPLE_RATE ?? 1);
let isSentryInitialized = false;
export default function SentryProvider({ children }) {
  const accountDetails = Cookies.get("accountDetails");
  const decrypted_account_details = decodeObject(accountDetails, process.env.REACT_APP_LOGIN_SALT);
  useEffect(() => {
    if (isProduction && process.env.REACT_APP_SENTRY_DSN && !isSentryInitialized) {
      if (!Sentry.getClient()) {
        Sentry.init({
          dsn: `${process.env.REACT_APP_SENTRY_DSN}`, // Your Sentry project’s connection string.
          sendDefaultPii: false, // is a Sentry SDK option that controls whether the SDK includes default Personally Identifiable Information (PII) in events it sends to the Sentry server.
          tracesSampleRate, // performance/transaction sampling rate
          tracePropagationTargets: [
            // determines which outgoing requests (XHR/fetch) should automatically propagate tracing headers.
            // "localhost",
            // "dev.carrum.co.in",
            // "qa.carrum.co.in",
            // "carrum.co.in",
          ],
          enableLogs: true,
          sampleRate: errorSampleRate, // error event sampling rate
          replaysSessionSampleRate: 0, //  record 100% of all sessions
          replaysOnErrorSampleRate: 0,
          ignoreErrors: [],
          autoSessionTracking: false,
          beforeSend(event) {
            delete event.user?.phone;
            return event;
          },
          beforeSendSpan(span) {
            if (span.op === "resource.img") {
              // console.log("sentry_span", span);
            }
            if (span.op === "http.client") {
              const url = span.description;
              if (typeof url === "string") {
                const parts = url.split("/");
                const uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
                const foundUuids = [];
                const sanitizedParts = parts.map((segment) => {
                  if (uuidRegex.test(segment)) {
                    foundUuids.push(segment);
                    return ":id";
                  }
                  return segment;
                });
                if (foundUuids.length > 0) {
                  const sanitizedUrl = sanitizedParts.join("/");
                  span.description = sanitizedUrl;
                  span.name = sanitizedUrl;
                }
              }
            }
          },
          breadcrumbs: {
            xhr: false,
            fetch: false,
            console: false,
            dom: false,
          },
          integrations: [
            // Sentry.replayIntegration(), // Enables session replay
            Sentry.captureConsoleIntegration({ levels: [] }), // Enables console logging
            // Sentry.consoleLoggingIntegration({ levels: ["warn", "error"] }), // create event for every log
            // Sentry.browserTracingIntegration({
            //   traceFetch: true, // span.op === "http.client"
            //   traceXHR: true,
            //   enableInpMonitoring: true,
            //   enableLongTask: true,
            //   enableHTTPLongTask: true,
            //   tracePerformance: true,
            //   startTransactionOnPageLoad: false,
            //   startTransactionOnLocationChange: false,
            //   enableNavigationTracking: false,
            // }), // disable tracing for browser requests
            // Sentry.httpClientIntegration({
            //   traceFetch: true,
            //   traceXHR: true,
            //   enableInpMonitoring: true,
            //   enableLongTask: true,
            //   enableHTTPLongTask: true,
            //   tracePerformance: true,
            //   startTransactionOnPageLoad: false,
            //   startTransactionOnLocationChange: false,
            //   enableNavigationTracking: false,
            // }), // disable tracing for http requests
          ],
          // release:""
          // environment: `${process.env.REACT_APP_ENV}`,
        });
        if (decrypted_account_details?.id) {
          let user = {
            id: decrypted_account_details?.id, // required: unique user identifier
            name: decrypted_account_details?.name, // optional
            email: decrypted_account_details?.email, // optional
          };
          if (decrypted_account_details?.role) {
            user.role = decrypted_account_details?.role[0];
          }
          if (decrypted_account_details?.hubs) {
            user.hub = decrypted_account_details?.hubs[0]?.hub_name;
          }
          Sentry.setUser(user);
        }

        isSentryInitialized = true;
      }
    }
  }, []);
  return children;
}
